import { Button, Card, CardDescription, CardTitle, cn, IconChevronRight } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';

export function SettingsList({ children, label }: { children: ReactNode; label: string }) {
  return (
    <Card className="border-steel-75 overflow-hidden bg-white font-sans shadow-none">
      <ul aria-label={label}>{children}</ul>
    </Card>
  );
}

export function SettingsListRow({
  title,
  description,
  metadata,
  onClick,
  actionLabel,
  isExpanded,
  truncateTitle = false,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  metadata?: ReactNode;
  onClick?: () => void;
  actionLabel?: string;
  isExpanded?: boolean;
  truncateTitle?: boolean;
  children?: ReactNode;
}) {
  const rowClassName = 'flex w-full items-start justify-between gap-4 p-4 text-left';
  const content = (
    <span className="min-w-0">
      <CardTitle className={cn('text-steel-500 leading-5', truncateTitle && 'truncate')}>{title}</CardTitle>
      {description ? <CardDescription className="text-steel-400 mt-1 leading-5">{description}</CardDescription> : null}
      {metadata ? (
        <span className="text-steel-400 mt-2 flex flex-wrap items-center gap-3 text-sm leading-4">{metadata}</span>
      ) : null}
    </span>
  );

  return (
    <li className="border-steel-75 border-b bg-white last:border-b-0">
      {onClick ? (
        <Button
          type="button"
          variant="transparent"
          className={cn(
            rowClassName,
            'hover:bg-steel-50 h-auto rounded-none font-normal whitespace-normal',
            'focus-visible:ring-offset-0 focus-visible:ring-inset',
          )}
          onClick={onClick}
          aria-label={actionLabel}
          aria-expanded={isExpanded}
        >
          {content}
          <IconChevronRight
            aria-hidden="true"
            className={cn('text-steel-300 mt-1 h-4 w-4 shrink-0 transition-transform', isExpanded && 'rotate-90')}
          />
        </Button>
      ) : (
        <div className={rowClassName}>{content}</div>
      )}
      {children}
    </li>
  );
}
